﻿import { Link } from 'react-router-dom'

/**
 * Standalone 404 page — rendered for unregistered paths.
 * Authentication not enforced for unregistered paths; keep outside AppLayout.
 */
export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-950 flex flex-col items-center justify-center gap-4 text-center px-4">
      <p className="text-6xl font-bold text-gray-600">404</p>
      <p className="text-xl font-semibold text-gray-200">Page not found</p>
      <p className="text-gray-500 max-w-sm">
        That path doesn't exist. Check the URL or head back to somewhere useful.
      </p>
      <Link to="/" className="mt-2 text-sm text-red-400 hover:text-red-300 underline underline-offset-2">
        Go home
      </Link>
    </div>
  )
}
